import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { putPurchaseFileRequest } from "../../../../../Backend/BooksRequests";
import "./PurchaseFileModal.scss";

export function PurchaseFileModal({ ...props }) {
  const [t] = useTranslation();
  const [file, setFile] = useState(null);

  const sendPurchaseFile = async () => {
    const resp = await putPurchaseFileRequest(file);

    if (resp.success) {
      props.submit();
      props.onHide();
    }
  };

  return (
    <Modal {...props} centered dialogClassName="purchase-file-modal">
      <Modal.Header closeButton />
      <Modal.Body>
        <div className="title">{t("PurchaseFile")}</div>
        <div className="text">{t("PurchaseFileText")}</div>
        <div className="uploader">
          <FileUploader
            handleChange={(x) => setFile(x)}
            name="file"
            types={["csv"]}
          />
        </div>
        <div className="buttons-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Cancel")}
          </Button>
          <Button className="button-save" onClick={() => sendPurchaseFile()}>
            {t("Save")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
